<template>
  <v-flex>
    <v-text-field
      :label="$t('label') + (required ? '*' : '')"
      :error-messages="errorMessages"
      :value="value"
      :rules="[$rules.isRequired, $rules.isValidEmail]"
      @input="email => $emit('input', email)"
    />
  </v-flex>
</template>

<script>
export default {
  name: 'EmailInput',
  props: [
    'value',
    'errorMessages',
    'required'
  ],
  i18n: {
    messages: {
      en: {
        label: 'Email'
      },
      tr: {
        label: 'E-posta'
      },
      de: {
        label: 'Email'
      },
      ru: {
        label: 'Эл. адрес'
      }
    }
  }
}
</script>
